import SecurityCheckForm from './SecurityCheckForm';

export default SecurityCheckForm;
